import type { PluginSimple } from 'markdown-it';

/**
 * A Markdown plugin for handling mentions.
 *
 * Example:
 *
 * input:
 * ```md
 * @mention:{type:deal,id:1,title:Deal 1,state:active}
 * ```
 *
 * output:
 * ```js
 * {
 *   "type": "mention",
 *   "attrs": {
 *     "type": "deal",
 *     "id": 1,
 *     "title": "Deal 1",
 *     "state": "active"
 *   }
 * }
 *
 * @param md - The Markdown-it instance.
 */
export const mentionPlugin: PluginSimple = (md) => {
  md.inline.ruler.push('mention', (state, silent) => {
    const mentionRegex = /@mention:\{([^}]+)\}/;
    const match = mentionRegex.exec(state.src.slice(state.pos));

    if (!match) return false;
    if (silent) return false;

    const token = state.push('mention', '', 0);
    token.content = match[1];
    state.pos += match[0].length;

    return true;
  });
};
